import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import {
  getAuthenticatedHomePath,
  hasAuthSession,
  isAuthGuestPath,
  isMemberUser,
  isOnboardingPath,
} from "../../helpers/routeAccess"
import { getCityHubPathFromPublicEngage } from "../../pages/PublicCity/publicCityPaths"

/**
 * Keeps logged-in users off login/signup routes (including browser Back).
 * Redirect runs on route entry only — not when auth updates in-place (e.g. create-account → onboarding).
 * Public-city engage CTAs with cityId → City Hub tab (not dashboard).
 */
const GuestAuthMiddleware = ({ children }) => {
  const authToken = useSelector(state => state.auth.jid)
  const currentUser = useSelector(state => state.auth.currentUser)
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!hasAuthSession(authToken) || !currentUser) return

    if (
      isAuthGuestPath(location.pathname) &&
      !isOnboardingPath(location.pathname)
    ) {
      const engageState = location.state
      if (
        isMemberUser(currentUser) &&
        engageState?.from === "public-city" &&
        engageState?.cityId
      ) {
        const hubPath = getCityHubPathFromPublicEngage({
          cityId: engageState.cityId,
          tab: engageState.tab,
        })
        if (hubPath) {
          navigate(hubPath, {
            replace: true,
            state: engageState.city
              ? { city: engageState.city, from: "public-city" }
              : { from: "public-city", cityId: engageState.cityId },
          })
          return
        }
      }
      navigate(getAuthenticatedHomePath(currentUser), { replace: true })
    }
    // Only redirect when entering a guest route — not when auth updates in-place.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- authToken/currentUser/state read on pathname change
  }, [location.pathname, navigate])

  return children
}

export default GuestAuthMiddleware
